module.exports = __webpack_public_path__ + "static/media/thumb-carton.04764bfb.png";